import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OrderFormComponent } from 'src/app/shared/components/enter-order/order-form/order-form.component';
import { ICollectOrderDetailsFormValue } from '../../interfaces/ICollectOrderDetailsFormValue';
import { highlightRequiredControlsWithErrors } from 'src/app/shared/helpers/helpers';

@Component({
  selector: 'app-order-details-dialog',
  templateUrl: './order-details-dialog.component.html',
  styleUrls: ['./order-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailsDialogComponent implements OnInit {

  @Input() header: string = 'Enter Order Details';
  @Input() initialValue: ICollectOrderDetailsFormValue;
  @Input() saveBtnText: string = 'Add';

  @Output() canceled: EventEmitter<void> = new EventEmitter();
  @Output() saved: EventEmitter<ICollectOrderDetailsFormValue> = new EventEmitter<ICollectOrderDetailsFormValue>();

  @ViewChild('orderForm') orderFormComponent: OrderFormComponent;

  constructor() { }

  ngOnInit(): void {
  }

  collectFormData() {
    if(this.orderFormComponent.form.invalid) {
      this.orderFormComponent.highlightRequiredControlsWithErrors();
      this.orderFormComponent.supplierBuyerDetails.highlightRequiredControlsWithErrors();
      return;
    }
    const data = this.orderFormComponent.form.getRawValue() as ICollectOrderDetailsFormValue;
    data.buyerDetails = this.orderFormComponent.buyer;
    data.supplierDetails = this.orderFormComponent.supplier;
    this.saved.emit(data);
  }

}
